import ConfigurationAdapter from '../../../../config/ConfigurationAdapter';
import { customerCredentials } from '../../../Auth/Domain/Credentials';
import APIv4AuthCredentialsRepository from '../../../Auth/Infrastructure/Repositories/APIv4AuthCredentialsRepository';
import APIv4CustomerRepository from '../../Infraestructure/Repositories/APIv4CustomerRepository';
import { ForgotPasswordHandler } from './ForgotPassword';
import { GetCustomerHandler } from './GetCustomer';
import { LoginHandler } from './Login';
import { RegisterHandler } from './Register';
import { ResetPasswordHandler } from './ResetPassword';
import { SubscribeNewsletterHandler } from './SubscribeNewsletter';
import { TryGetCustomerHandler } from './TryGetCustomer';
import { UpdateCustomerInfoHandler } from './UpdateCustomerInfo';
export const loginUseCase = context => {
  const v4Context = ConfigurationAdapter.getV4Context(context);
  const setCredentiaslWrap = credentials => customerCredentials.setCredentials(context, credentials.accessToken);
  return new LoginHandler(new APIv4CustomerRepository(v4Context, context.drivers.httpClient), setCredentiaslWrap);
};
/**
 * FIXME: The logout is not implemented, as we are using M2M login/logout.
 * For M2M, use removeCredentialsM2MUseCase() instead.
 **/
export const logOutUseCase = () => {
  throw new Error('Logout not implemented');
};
/**
 * This use case removes the credentials but don't logout. In M2M, the logout has been already done in v4.
 **/
export const removeCredentialsM2MUseCase = context => {
  customerCredentials.removeCredentials(context);
};
export const registerUseCase = context => {
  const v4Context = ConfigurationAdapter.getV4Context(context);
  return new RegisterHandler(new APIv4CustomerRepository(v4Context, context.drivers.httpClient), new APIv4AuthCredentialsRepository(v4Context, context.drivers.httpClient));
};
export const isLoggedUseCase = context => {
  return customerCredentials.getValidCreadentials$(context);
};
export const forgotPasswordUseCase = context => {
  const v4Context = ConfigurationAdapter.getV4Context(context);
  return new ForgotPasswordHandler(new APIv4CustomerRepository(v4Context, context.drivers.httpClient));
};
export const resetPasswordUseCase = context => {
  const v4Context = ConfigurationAdapter.getV4Context(context);
  return new ResetPasswordHandler(new APIv4CustomerRepository(v4Context, context.drivers.httpClient), new APIv4AuthCredentialsRepository(v4Context, context.drivers.httpClient));
};
export const updateCustomerInfoUseCase = context => {
  const v4Context = ConfigurationAdapter.getV4Context(context);
  return new UpdateCustomerInfoHandler(new APIv4CustomerRepository(v4Context, context.drivers.httpClient), new APIv4AuthCredentialsRepository(v4Context, context.drivers.httpClient));
};
export const getCustomerUseCase = context => {
  const v4Context = ConfigurationAdapter.getV4Context(context);
  return new GetCustomerHandler(new APIv4CustomerRepository(v4Context, context.drivers.httpClient), context);
};
export const tryGetCustomerUseCase = context => {
  const v4Context = ConfigurationAdapter.getV4Context(context);
  return new TryGetCustomerHandler(new APIv4CustomerRepository(v4Context, context.drivers.httpClient), context);
};
export const loginM2MUseCase = (context, credentials) => {
  customerCredentials.setCredentials(context, credentials);
};
export const subscribeToNewsletterUseCase = context => {
  const v4Context = ConfigurationAdapter.getV4Context(context);
  return new SubscribeNewsletterHandler(new APIv4CustomerRepository(v4Context, context.drivers.httpClient), new APIv4AuthCredentialsRepository(v4Context, context.drivers.httpClient));
};
